import { useFlags } from 'launchdarkly-react-client-sdk';
import { useLocation } from 'react-router-dom';

import { ROUTES } from 'enumsV2';

// The only pages where the print order feature lives. Note: exact pathnames on
// purpose — `/resources/favorites` (the Favorites page) and other subpaths are
// NOT print-order surfaces.
const PRINT_ORDER_PATHS: string[] = [ROUTES.HOME, ROUTES.RESOURCES];

/**
 * Whether the print order (shopping cart) feature is active in this context.
 *
 * On behind the `shoppingCart` LD flag, only on the Home and Resources pages.
 * Everywhere else (Favorites, My Files, embeds, the Outlook dialog pages, …)
 * the whole feature stays hidden: no "Add to Cart" in the resource dropdown,
 * no "In Cart" badge, no cart restore call, no floating cart bar.
 */
/**
 * Whether this is a print-order company context at all: the `shoppingCart` LD
 * flag. Page-independent — used by the resource preview dialog, which opens
 * everywhere, including the Outlook add-in dialogs (they render the full web
 * page in an Office dialog window, so the preview dialog fits there).
 */
export const usePrintOrderCompany = (): boolean => {
  const flags = useFlags();

  return !!flags?.shoppingCart;
};

export const usePrintOrderEnabled = (): boolean => {
  const isPrintOrderCompany = usePrintOrderCompany();
  const { pathname } = useLocation();

  // Normalize a possible trailing slash ("/resources/" → "/resources").
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';
  const isPrintOrderPage = PRINT_ORDER_PATHS.includes(normalizedPath);

  return isPrintOrderCompany && isPrintOrderPage;
};
